export const PROD_SONY_SCENARIO_ID = '9crbw4zgit';
const DEV_SONY_SCENARIO_ID = 'ed988qf9c6';
const INTERNAL_SONY_SCENARIO_ID = 'ygoyfo9joa';
const TEST_SONY_SCENARIO_ID = 'vmucmrbycs';
const SONY_EUROPE_EMAIL_COPILOT_SCENARIO_ID = 'gigau00y4c';
const SONY_TRIAGE_DEMO_SCENARIO_ID = 'ahjsktqy14';
// Mirror of ALL_SONY_SCENARIO_IDS in quickchat/implementations/scenario_ids.py, the server-side sony-admin gate — parity enforced by test_frontend_scenario_id_parity.py.
export const SONY_ADMIN_SCENARIO_IDS = [
  PROD_SONY_SCENARIO_ID,
  DEV_SONY_SCENARIO_ID,
  INTERNAL_SONY_SCENARIO_ID,
  TEST_SONY_SCENARIO_ID,
  SONY_EUROPE_EMAIL_COPILOT_SCENARIO_ID,
];
// Mirror of TRIAGE_DATA_EXPORT_ALLOWED_SCENARIO_IDS in quickchat/implementations/scenario_ids.py, which is the server-side gate — parity enforced by test_frontend_scenario_id_parity.py.
export const TRIAGE_DATA_EXPORT_ALLOWED_SCENARIO_IDS = [
  PROD_SONY_SCENARIO_ID,
  SONY_TRIAGE_DEMO_SCENARIO_ID,
  'nve1qd_dev_admin', // local Krzysztofs scenario id
];
export const QUICKCHAT_SUPPORT_BOT_SCENARIO_ID = 'qj6hw2tua6';
export const DEV_QUICKCHAT_SUPPORT_BOT_SCENARIO_ID = 'uof2azxlgp_dev';
export const SOLVERA_SCENARIO_ID = 'dty73tkoet';

// Custom-tier scenarios that still receive activity-summary emails. Mirror of ALWAYS_INCLUDED_SCENARIO_IDS in quickchat/activity_summary/consts.py — parity enforced by test_frontend_scenario_id_parity.py.
export const EMAIL_SUMMARY_ALWAYS_INCLUDED_SCENARIO_IDS = [
  QUICKCHAT_SUPPORT_BOT_SCENARIO_ID,
  PROD_SONY_SCENARIO_ID,
  SONY_EUROPE_EMAIL_COPILOT_SCENARIO_ID,
  SOLVERA_SCENARIO_ID,
];
